var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Meta, Title } from '@angular/platform-browser';
import { LocaleAwareBaseComponent } from './locale-aware-base.component';
import { DOCUMENT } from '@angular/platform-browser';
var SeoAwareBaseComponent = /** @class */ (function (_super) {
    __extends(SeoAwareBaseComponent, _super);
    function SeoAwareBaseComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.meta = _this.injector.get(Meta);
        _this.title = _this.injector.get(Title);
        var document = _this.injector.get(DOCUMENT);
        var window = _this.injector.get('WINDOW');
        if (document && window) {
            if (window.location && window.location.href.includes('gclid=')) {
                SeoAwareBaseComponent.referrer_url = 'https://googleadservices.com';
            }
            else if (window.location && window.location.href.includes('fbclid=')) {
                SeoAwareBaseComponent.referrer_url = 'https://facebook.com';
            }
            else if (document.referrer && !document.referrer.startsWith(window.location.protocol + '//' + window.location.hostname)) {
                SeoAwareBaseComponent.referrer_url = document.referrer;
            }
            if (window.location && window.location.href) {
                var utm_source = SeoAwareBaseComponent.getQueryParam(window.location.href, 'utm_source');
                if (utm_source)
                    SeoAwareBaseComponent.utm_source = utm_source;
                var utm_medium = SeoAwareBaseComponent.getQueryParam(window.location.href, 'utm_medium');
                if (utm_medium)
                    SeoAwareBaseComponent.utm_medium = utm_medium;
                var utm_campaign = SeoAwareBaseComponent.getQueryParam(window.location.href, 'utm_campaign');
                if (utm_campaign)
                    SeoAwareBaseComponent.utm_campaign = utm_campaign;
            }
        }
        if (document) {
            var link = document.head.querySelector('[rel="canonical"]');
            if (!link) {
                link = document.createElement('link');
                document.head.appendChild(link);
            }
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', document.URL);
        }
        if (!SeoAwareBaseComponent.referrer_url) {
            try {
                SeoAwareBaseComponent.referrer_url = localStorage.getItem('last_referrer_url');
                /* tslint:disable:no-empty */
            }
            catch (e) { }
            /* tslint:enable */
        }
        else {
            try {
                localStorage.setItem('last_referrer_url', SeoAwareBaseComponent.referrer_url);
                /* tslint:disable:no-empty */
            }
            catch (e) { }
            /* tslint:enable */
        }
        return _this;
    }
    SeoAwareBaseComponent.getQueryParam = function (url, param) {
        // https://dev.to/ganeshmani/how-to-get-query-string-parameters-in-javascript-2019-4dm2
        var href = url;
        // this expression is to get the query strings
        var reg = new RegExp('[?&]' + param + '=([^&#]*)', 'i');
        var queryString = reg.exec(href);
        return queryString ? queryString[1] : null;
    };
    SeoAwareBaseComponent.prototype.setTitle = function (messageToTranslate, additionalText) {
        var _title = (additionalText ? additionalText + ' - ' : '') + messageToTranslate;
        if (!this.isNullOrEmpty(_title)) {
            this.title.setTitle(_title);
            this.meta.removeTag('name=\'og:title\'');
            this.meta.removeTag('property=\'og:title\'');
            this.meta.removeTag('name=\'twitter:title\'');
            this.meta.removeTag('property=\'twitter:title\'');
            this.meta.addTags([
                { name: 'og:title', content: _title },
                { name: 'twitter:title', content: _title }
            ]);
        }
    };
    SeoAwareBaseComponent.prototype.setMetaDescription = function (description) {
        this.meta.removeTag('name=\'description\'');
        this.meta.removeTag('property=\'description\'');
        this.meta.removeTag('name=\'og:description\'');
        this.meta.removeTag('property=\'og:description\'');
        this.meta.removeTag('name=\'twitter:description\'');
        this.meta.removeTag('property=\'twitter:description\'');
        this.meta.addTags([
            { name: 'description', content: description },
            { name: 'og:description', content: description },
            { name: 'twitter:description', content: description }
        ]);
    };
    SeoAwareBaseComponent.prototype.isNullOrEmpty = function (value) {
        return value !== false && !value;
    };
    return SeoAwareBaseComponent;
}(LocaleAwareBaseComponent));
export { SeoAwareBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/seo/seo-aware-base.component.ts.pre-build-optimizer.js